import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import ScrollToPlugin from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

window.addEventListener('frame-ready', init)

function init() {

    const PAGE = document.querySelector('.CookeryBooksHistory')

    if(!PAGE) return

    const years = Array.from(document.querySelectorAll('[data-pointer]')) // Year navigation items
    const panels = Array.from(document.querySelectorAll('.cook-book-panel'))

    let { hash } = window.location

    function movePointer(id) {
        const pointer = document.querySelector('.pointer-wrapper svg') // Finger
        const year = document.querySelector(`[data-pointer="${id}"]`) // Year navigation
        const index = Array.from(year.parentNode.children).indexOf(year) // Position of year
        const rect = year.getBoundingClientRect()
        years.forEach(year => year.classList.remove('current'))
        year.classList.add('current')
        gsap.to(pointer, { translateY: rect.height * index}) // Move pointer to height * index
    }

    if(hash) {
        // @TODO Check if hash is one of the existing years
        movePointer(hash.substr(1, hash.length - 1))
    }

    if(years.length > 0) {
        years.forEach(year => {
            year.addEventListener('click', (e) => {
                e.preventDefault()
                window.history.replaceState({}, '', e.target.href);

                let { hash } = window.location
                gsap.to(window, { duration: .5, scrollTo: hash })
                movePointer(hash.substr(1, hash.length - 1))

            })
        })
    }

    function onEnterPanel(panel) {
        movePointer(panel.id)
    }

    if(panels.length > 0) {
        panels.forEach( panel => {

            const year = panel.querySelector('.year')
            const edition = panel.querySelector('.edition')
            const details = panel.querySelector('.details')
            const image = panel.querySelector('.timeline-content--image')

            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: panel,
                    // markers: true,
                    start: 'top center',
                    end: 'bottom center',
                    toggleActions: 'play reverse play reverse',
                    onEnter: () => onEnterPanel(panel),
                    onEnterBack: () => onEnterPanel(panel)
                }
            })

            tl.to([year, edition, details, image], {
                stagger: {
                    amount: 0.1
                },
                opacity: 1,
                translateX: 0,
                translateY: 0,
            })
        })
    }

    function checkDimensions() {

        const hasAutoHeight = panels[0].classList.contains('auto-height')
        const isTall = window.innerHeight > window.innerWidth

        if(isTall && !hasAutoHeight) {
            panels.forEach(panel => panel.classList.add('auto-height'))
        }

        if(!isTall && hasAutoHeight) {
            panels.forEach(panel => panel.classList.remove('auto-height'))
        }
    }

    checkDimensions()

    window.addEventListener('resize', () => {
        checkDimensions()
    })
}
